import type { StrategyMode } from "./types";

const STRATEGY_TEMPLATE_IDS = new Map<string, string>([
  ["ma cross", "ma_cross"],
  ["pullback", "pullback"],
  ["breakout", "breakout"],
  ["engulfing", "engulfing"],
  ["pin bar", "pin_bar"],
  ["inside bar", "inside_bar"],
  ["sweep", "sweep"],
  ["rsi", "rsi"],
  ["bollinger", "bollinger"],
  ["macd", "macd"],
  ["trend+", "trend_plus"],
  ["vol break", "vol_break"],
  ["mean+", "mean_plus"],
  ["mtf", "mtf"],
]);

export type BacktestStrategyAnalyticsParameters = {
  strategy_source: "preset" | "manual" | "builder" | "method";
  strategy_template_id?: string;
};

/**
 * Returns bounded analytics dimensions without copying a user-authored strategy
 * name or prompt into telemetry. Template identifiers are emitted only for the
 * product-owned preset allowlist above.
 */
export function backtestStrategyAnalyticsParameters(
  strategyMode: StrategyMode,
  strategyName: string,
): BacktestStrategyAnalyticsParameters {
  if (strategyMode === "method") return { strategy_source: "method" };
  if (strategyMode === "manual") return { strategy_source: "manual" };
  if (strategyMode === "builder") return { strategy_source: "builder" };

  const strategyTemplateID = STRATEGY_TEMPLATE_IDS.get(strategyName.trim().toLowerCase());
  return strategyTemplateID
    ? { strategy_source: "preset", strategy_template_id: strategyTemplateID }
    : { strategy_source: "preset" };
}
